// extracted by mini-css-extract-plugin
export default {"display":"App_display__DXpLJ","chat":"App_chat__cTZbY","history":"App_history__tk1xl","squareButton":"App_squareButton__iRIfg","container":"App_container__Rt8T2"};